import { queryOptions } from "@tanstack/react-query";
import {
  listAccessoryPhotosBaseline,
  listModels,
  listModelTemplates,
  listNotesForModel,
} from "@/modules/plus/data/plus.data.api";

export const dataKeys = {
  models: ["data", "models"] as const,
  templates: ["data", "model_templates"] as const,
  accessoryBaseline: ["data", "accessory_photos_baseline"] as const,
  notes: (modelCode: string) => ["data", "model_notes", modelCode] as const,
} as const;

// Bulk reference data — small (51 templates, ~1k models) and rarely changes.
// 5-min stale time lets edits propagate without thrashing on every nav.
export const modelsQueryOptions = () =>
  queryOptions({
    queryKey: dataKeys.models,
    queryFn: listModels,
    staleTime: 5 * 60 * 1000,
  });

export const modelTemplatesQueryOptions = () =>
  queryOptions({
    queryKey: dataKeys.templates,
    queryFn: listModelTemplates,
    staleTime: 5 * 60 * 1000,
  });

export const accessoryPhotosBaselineQueryOptions = () =>
  queryOptions({
    queryKey: dataKeys.accessoryBaseline,
    queryFn: listAccessoryPhotosBaseline,
    staleTime: 5 * 60 * 1000,
  });

export const notesQueryOptions = (modelCode: string) =>
  queryOptions({
    queryKey: dataKeys.notes(modelCode),
    queryFn: () => listNotesForModel(modelCode),
    staleTime: 30 * 1000,
  });
